<script>
export default {
  name: "FindProviderPage",
  data() {
    return {
      embedURL: process.env.VUE_APP_EMBED_URL,
      sessionToken: "",
      sessionLoading: false,
      showScheduleDialog: false,
      selectedProvider: null,
      providersKeys: [],
      PROVIDERS: [
        {
          score: 32,
          npi: "1750709796",
          integrations: null,
          providerTypes: [],
          firstName: "Tyson",
          middleName: "Dean",
          lastName: "Steel",
          age: 0,
          address: "1308 8th St Ste 1",
          degrees: null,
          gender: "m",
          specialties: ["Internal Medicine"],
          phoneNumber: "(208)436-4322",
          insurances: [
            "UnitedHealthcare",
            "First Administrators",
            "All Other Third Party",
            "Health Alliance (HAMP)",
            "OptumRx",
            "Medicare Part B",
            "Express Scripts",
            "Medicare Part A",
            "Not Specified",
            "State of Idaho",
            "Molina",
            "Blue Cross of Idaho",
            "IHC / SelectHealth",
          ],
          latitude: 42.61956,
          longitude: -113.68734,
          distance: 1226.29,
          hospital: "",
          telehealth: false,
          hasSchedule: false,
          hasScore: false,
          avatar: "https://placehold.co/150",
          minPrice: 0,
          isSaved: false,
          phoneNumbers: [
            {
              details: "primary",
              address: "1308 8th St Ste 1",
              phone: "2084364322",
            },
          ],
          scheduleKey: "1750709796-15128856006",
          operationalHours: [
            '"monday-16"',
            '"monday-17"',
            '"monday-18"',
            '"monday-19"',
            '"monday-20"',
            '"monday-21"',
            '"tuesday-16"',
            '"tuesday-17"',
            '"tuesday-18"',
            '"tuesday-19"',
            '"tuesday-20"',
            '"tuesday-21"',
            '"wednesday-16"',
            '"wednesday-17"',
            '"wednesday-18"',
            '"wednesday-19"',
            '"wednesday-20"',
            '"wednesday-21"',
            '"thursday-16"',
            '"thursday-17"',
            '"thursday-18"',
            '"thursday-19"',
            '"thursday-20"',
            '"thursday-21"',
            '"friday-16"',
            '"friday-17"',
            '"friday-18"',
            '"friday-19"',
            '"friday-20"',
            '"friday-21"',
          ],
        },
        {
          score: 32,
          npi: "1760419550",
          integrations: null,
          providerTypes: [],
          firstName: "Scott",
          middleName: "W",
          lastName: "Birch",
          age: 0,
          address: "3344 N Futrall Dr",
          degrees: null,
          gender: "m",
          specialties: ["Internal Medicine"],
          phoneNumber: "(479)521-8200",
          insurances: [
            "6 Degrees Health",
            "CVS Health",
            "Point32Health",
            "First Health Group",
            "Express Scripts",
            "Centene",
            "Medicare Part A",
            "UnitedHealthcare",
            "Not Specified",
            "All Other Third Party",
            "Blue Cross Blue Shield of Arkansas",
            "Medicare Part B",
          ],
          latitude: 36.11084,
          longitude: -94.16266,
          distance: 453.62,
          hospital: "",
          telehealth: false,
          hasSchedule: false,
          hasScore: false,
          avatar: "https://placehold.co/150",
          minPrice: 0,
          isSaved: false,
          phoneNumbers: [
            {
              details: "primary",
              address: "3344 N Futrall Dr",
              phone: "4795218200",
            },
          ],
          scheduleKey: "1760419550-15128856006",
          operationalHours: [
            '"monday-15"',
            '"monday-16"',
            '"monday-17"',
            '"monday-18"',
            '"monday-19"',
            '"monday-20"',
            '"tuesday-15"',
            '"tuesday-16"',
            '"tuesday-17"',
            '"tuesday-18"',
            '"tuesday-19"',
            '"tuesday-20"',
            '"wednesday-15"',
            '"wednesday-16"',
            '"wednesday-17"',
            '"wednesday-18"',
            '"wednesday-19"',
            '"wednesday-20"',
            '"thursday-15"',
            '"thursday-16"',
            '"thursday-17"',
            '"thursday-18"',
            '"thursday-19"',
            '"thursday-20"',
            '"friday-15"',
            '"friday-16"',
            '"friday-17"',
            '"friday-18"',
            '"friday-19"',
            '"friday-20"',
          ],
        },
        {
          score: 32,
          npi: "1679862023",
          integrations: null,
          providerTypes: [],
          firstName: "Apolinar",
          middleName: "B",
          lastName: "Bordador",
          age: 0,
          address: "10001 Lile Dr",
          degrees: null,
          gender: "m",
          specialties: ["Internal Medicine"],
          phoneNumber: "(501)227-8000",
          insurances: [
            "All Other Third Party",
            "Blue Cross Blue Shield of Michigan",
            "Point32Health",
            "Department of Defense / Tricare",
            "UnitedHealthcare",
            "Medicare Part A",
            "Humana",
            "Not Specified",
            "Medicare Part B",
            "Blue Cross Blue Shield of Arkansas",
            "CVS Health",
            "Express Scripts",
          ],
          latitude: 34.74567,
          longitude: -92.38554,
          distance: 439.38,
          hospital: "",
          telehealth: false,
          hasSchedule: false,
          hasScore: false,
          avatar: "https://placehold.co/150",
          minPrice: 0,
          isSaved: false,
          phoneNumbers: [
            {
              details: "primary",
              address: "10001 Lile Dr",
              phone: "5012278000",
            },
          ],
          scheduleKey: "1679862023-15128856006",
          operationalHours: [
            '"monday-15"',
            '"monday-16"',
            '"monday-17"',
            '"monday-18"',
            '"monday-19"',
            '"monday-20"',
            '"tuesday-15"',
            '"tuesday-16"',
            '"tuesday-17"',
            '"tuesday-18"',
            '"tuesday-19"',
            '"tuesday-20"',
            '"wednesday-15"',
            '"wednesday-16"',
            '"wednesday-17"',
            '"wednesday-18"',
            '"wednesday-19"',
            '"wednesday-20"',
            '"thursday-15"',
            '"thursday-16"',
            '"thursday-17"',
            '"thursday-18"',
            '"thursday-19"',
            '"thursday-20"',
            '"friday-15"',
            '"friday-16"',
            '"friday-17"',
            '"friday-18"',
            '"friday-19"',
            '"friday-20"',
          ],
        },
      ],
    };
  },
  methods: {
    async fetchSession() {
      const body = {
        address: "1602 Main St, Crossett, AR, 71635",
        birthday: "1980-03-14",
        email: "m.lawson@example.com",
        firstName: "Michael",
        gender: "m",
        id: "12345",
        insuranceCompany: "members first",
        insurancePlan: "",
        insuranceGroupId: "",
        insuranceMemberId: "23807846",
        lastName: "Lawson",
        phone: "+15125551212",
        tenantKey: process.env.VUE_APP_TENANT_KEY,
        partnerKey: process.env.VUE_APP_PARTNER_KEY,
      };

      this.sessionLoading = true;
      const response = await fetch(
        `${process.env.VUE_APP_API_URL}/v2/session`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify(body),
        }
      );
      this.sessionLoading = false;

      const data = await response.json();

      if (data) {
        this.sessionToken = data.token;
      } else {
        console.error("Failed to fetch session token");
      }
    },
    async openScheduleDialog(provider) {
      await this.fetchSession();
      this.selectedProvider = provider;
      this.showScheduleDialog = true;
    },
    closeScheduleDialog() {
      this.showScheduleDialog = false;
      this.selectedProvider = null;
      this.sessionToken = "";
    },
  },
  mounted() {
    this.providersKeys = this.PROVIDERS.filter(
      (provider) => !!provider.scheduleKey
    ).map((provider) => provider.scheduleKey);

    window.addEventListener("message", (event) => {
      if (event.data.type === "pg-embed-schedule-ready") {
        const pgEmbedIframe = document.getElementById("pg-embed");

        if (pgEmbedIframe && this.sessionToken) {
          pgEmbedIframe.contentWindow.postMessage(
            {
              type: "sessionToken",
              token: this.sessionToken,
            },
            this.embedURL
          );
        }
      }
    });
  },
};
</script>

<template>
  <section class="find-provider-page">
    <h1 class="logo-text">Find a provider</h1>

    <div class="providers">
      <div v-for="provider in PROVIDERS" :key="provider.npi" class="provider">
        <img :src="provider.avatar" alt="Provider Image" class="image" />
        <h2>{{ provider.name }}</h2>
        <p>
          <strong>{{ provider.specialties[0] }}</strong>
        </p>
        <p>Location: {{ provider.address }}</p>
        <p>Phone: +1{{ provider.phoneNumber }}</p>

        <button
          @click="openScheduleDialog(provider)"
          :disabled="sessionLoading"
        >
          Schedule
        </button>
      </div>
    </div>

    <div v-if="showScheduleDialog" class="schedule-dialog-overlay">
      <div class="schedule-dialog">
        <div class="dialog-header">
          <h3>Schedule with {{ selectedProvider.name }}</h3>
          <button class="close-button" @click="closeScheduleDialog">×</button>
        </div>
        <div class="dialog-content">
          <iframe
            id="pg-embed"
            :src="`${embedURL}?targetScheduleKey=${selectedProvider.scheduleKey}&providers=${providersKeys}&primaryColor=%23094D8F`"
            width="100%"
            height="100%"
            frameborder="0"
            allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowfullscreen
          ></iframe>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@import "@/assets/style/global.scss";
@import "@/assets/style/mixins.scss";

.find-provider-page {
  width: 100%;
  max-width: 1024px;
  margin: 0 auto;
  padding: 0 16px;
  background-color: #ebf3fb;
}

.logo-text {
  font-size: 24px;
  text-align: center;
  margin-top: 8px;
  margin-bottom: 24px;
  font-weight: 700;
}

.providers {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
  gap: 16px;
}

.provider {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: var(--box-shadow-default);
  margin-bottom: 24px;

  .image {
    width: 150px;
    height: 150px;
    border-radius: 50%;
    margin-bottom: 16px;
  }

  h2 {
    font-size: 20px;
    font-weight: bold;
    margin-bottom: 8px;
  }

  p {
    font-size: var(--font-small);
    margin-bottom: 8px;
    text-align: center;
  }

  button {
    padding: 8px 16px;
    background-color: var(--primary-color);
    color: #fff;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    font-size: var(--font-small);
    font-weight: bold;

    &:disabled {
      background-color: #ccc;
    }
  }
}

.schedule-dialog-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: flex-end;
  align-items: center;
  z-index: 999;
}

.schedule-dialog {
  display: grid;
  grid-template-rows: auto 1fr;
  width: 100%;
  max-width: 400px;
  height: 100%;
  background-color: white;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);

  @media screen and (max-width: 768px) {
    width: 100%;
    height: 100%;
  }
}

.dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  background-color: var(--primary-color);
  color: white;

  h3 {
    margin: 0;
    font-weight: 600;
  }

  .close-button {
    background: none;
    border: none;
    color: white;
    font-size: 24px;
    cursor: pointer;
    padding: 0 8px;
  }
}

.dialog-content {
  height: 100%;
}
</style>
